import React from 'react';
import RejectModal from './RejectModal';
import PositiveModal from './PositiveModal';
import NegativeModal from './NegativeModal';
import AcceptModal from './AcceptModal';
import DeclineModal from './DeclineModal';
import IntermediateModal from './IntermediateModal';
import ApproveSupplierApplicationsModal from './ApproveSupplierApplicationsModal';
import ReturnRevisionSupplierApplications from './ReturnRevisionSupplierApplications';
import RejectRevisionSupplierApplications from './RejectRevisionSupplierApplications';
import CompletePositiveSupplierApplication from './CompletePositiveSupplierApplication';
import CompletePositiveSupplierChangeLocation from './CompletePositiveSupplierChangeLocation';
import RejectSupplierChangeLocation from './RejectSupplierChangeLocation';

function OperationsModals({ data, close }) {
  return (
    <>
      {data.name === 'accept' && <AcceptModal id={data.id} onClose={close} />}
      {data.name === 'reject' && <RejectModal id={data.id} onClose={close} />}
      {data.name === 'positive' && <PositiveModal id={data.id} onClose={close} />}
      {data.name === 'negative' && <NegativeModal id={data.id} onClose={close} />}
      {data.name === 'revision' && <DeclineModal id={data.id} onClose={close} />}
      {data.name === 'intermediate' && <IntermediateModal id={data.id} onClose={close} />}
      {data.name === 'approveSupplierApplications' && <ApproveSupplierApplicationsModal id={data.id} onClose={close} />}
      {data.name === 'returnRevisionSupplierApplications' && <ReturnRevisionSupplierApplications id={data.id} onClose={close} />}
      {data.name === 'rejectRevisionSupplierApplications' && <RejectRevisionSupplierApplications id={data.id} onClose={close} />}
      {data.name === 'completePositiveSupplierApplication' && <CompletePositiveSupplierApplication id={data.id} onClose={close} />}
      {data.name === 'completePositiveSupplierChangeLocation' && <CompletePositiveSupplierChangeLocation id={data.id} onClose={close} />}
      {data.name === 'rejectSupplierChangeLocation' && <RejectSupplierChangeLocation id={data.id} onClose={close} />}
    </>
  );
}

export default OperationsModals;
